<mat-accordion multi>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Subscriptions
      </mat-panel-title>
      <mat-panel-description>
        Overview of subscriptions and their corresponding licenses.
        <mat-icon>subscriptions</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <t4-data-table #lblSubscriptions [rawData]="subscriptions" headline="" matSort matSortActive="Group" [allowPaging]="true" [allowFilter]="true" [autoGenerateColumns]="false" [filterFields]="['Name']" [allowExcel]="false" >

      <ng-container matColumnDef="Product">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 235px; display: flex; justify-content: center; align-items: center;">Product</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 235px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.Product?.Name}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="StartDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;">Start Date</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.StartDate | date:'longDate'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="EndDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;">End Date</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.EndDate | date:'longDate'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="LastInvoiceDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;">Last Invoiced</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.LastInvoiceDate}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="InvoiceSum">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;">Invoiced Sum</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.InvoiceCount}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="InvoiceCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;">Invoiced Count</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.InvoiceSum}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Remove">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;"></mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          <button color="primary" mat-icon-button (click)="endSubscription(row)" [disabled]="row.EndDate">
            <mat-icon style="vertical-align:baseline;">delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

    </t4-data-table>
    <button mat-flat-button color="primary" (click)="addEvent()">Add Subscription <mat-icon>add</mat-icon></button>
  </mat-expansion-panel>
  
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Active Assets Transactions
      </mat-panel-title>
      <mat-panel-description>
        Overview of all active asset transactions
        <mat-icon>list_alt</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <t4-data-table #lblAssets [rawData]="formatedAssets" headline="" matSort matSortActive="Group" [allowPaging]="true" [allowFilter]="true" [autoGenerateColumns]="false" [filterFields]="['Name']" [allowExcel]="false" >

      <ng-container matColumnDef="Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;">Product</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.Name}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="SerialId">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;">Serial ID</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.SerialId}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="StartDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;">Start Date</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.StartDate | date:'longDate'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="EndDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;">End Date</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.EndDate | date:'longDate'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="LastInvoiceDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;">Last Invoiced</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.LastInvoiceDate | date:'longDate'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Count">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;">Invoiced Count</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.Count}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="InvoiceSum">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; min-width: 100px; display: flex; justify-content: center; align-items: center;">Invoiced Sum</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px; text-align: center; display: flex; justify-content: center; align-items: center;">
          {{row.InvoiceSum}}
        </mat-cell>
      </ng-container>
    </t4-data-table>
  </mat-expansion-panel>


</mat-accordion>
